import React from "react";
import Dashboardcardlayout from "../Layout/Layout";
import myAssessmentIcon from "../../../images/Lightbulb.svg";
import Renderloitable from "./self-assessment-table";
import Renderpopoverslider from "../../Components/Self-assessment/popover-slider";
import { Modal, ModalBody } from "reactstrap";

const Renderloiassessment = (props) => {
  return (
    <div className="my-assessment-table custom-assessment-table">
      <Dashboardcardlayout
        headerIcon={myAssessmentIcon}
        headerText="My Assessments"
      >
        {props.overlayIsVisible && <div className="overlay"></div>}
        {/*wrap-table*/}
        <div className="">
          <Modal isOpen={props.isModalOpen} centered={true}>
            <ModalBody style={{ borderRadius: "10px" }}>
              <Renderpopoverslider
                sliderData={props.sliderData}
                handleSlideChange={props.handleSlideChange}
                showDots={props.showDots}
                instrument_id={props.instrument_id}
                user_id={props.user_id}
                participant__id={props.participant__id}
                instrumentMultiRater={props.instrumentMultiRater}
                organisation={props.organisation}
                seller={props.seller}
                completedCount={props.completedCount}
                assessmentType={props.assessmentType}
                slideIndex={props.slideIndex}
                invitationDetails={props.invitationDetails}
                startLink={props.startLink}
              />
            </ModalBody>
          </Modal>
          <Renderloitable
            userAssessmentDetails={props.userAssessmentDetails}
            showDots={props.showDots}
            toggleCollapse={props.toggleCollapse}
            collapseID={props.collapseID}
            handleAssessmentPopOver={props.handleAssessmentPopOver}
            handleClosePopOver={props.handleClosePopOver}
            isPopOverOpenAssessmentId={props.isPopOverOpenAssessmentId}
          />
        </div>
      </Dashboardcardlayout>
    </div>
  );
};

export default Renderloiassessment;



// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/self-assessment.jsx